import styled from "styled-components";

export const Drop = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;  
`;

export const DropButton = styled.button`
    height: 50px;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;  
    border: solid #e7e7e7;
    border-width: 2px;
    font-size: 12px;
    line-height: 12px;
    margin-left: 5px;
    border-radius: 5px;
    &:focus {
        border-color: #4b70b1;
        background-color: #f0f8ff;
        outline: none;
    }
`;

export const Menu = styled.ul`
    position: absolute;
    top: 100%; 
    background: white;
    border: 1px solid #ccc;
    z-index: 1000;
    left: 50%;
    transform: translateX(-50%);
    padding: 0;
    max-height: 400px;
    overflow-y: auto;
    width: 200px;
    border-radius: 5px;
`;

export const MenuItem = styled.li`
    padding: 0 20px;
    cursor: pointer;
    width: 200px;
    height: 50px;
    align-items: center;
    display: flex;
    justify-content: center;
    &:hover {
        background-color: #f0f0f0;
    }
`;

export const Arrow = styled.span`
    border: solid black;
    border-width: 0 1.5px 1.5px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    margin-left: 8px;
    margin-right: 3px;
    margin-bottom: 2.5px;
`;

export const Search = styled.input`
    width: 190px;
    height: 55px;
    border: none;
    margin: 5px;
    font-size: 12px;
    border-radius: 3px;
    &:hover {
        background-color: #f0f0f0; /* Light gray background */
    }
`;